import { record } from 'rrweb';
import {
  getRecordConsolePlugin,
  LogLevel,
} from '@rrweb/rrweb-plugin-console-record';

const defaultOptions = {
  recordOptions: {
    blockClass: 'bf-nocapture',
    blockSelector: undefined,
    ignoreClass: 'bf-ignore-input',
    ignoreCSSAttributes: undefined,
    maskTextClass: 'bf-mask',
    maskTextSelector: undefined,
    maskAllInputs: true,
    maskInputOptions: { password: true },
    maskInputFn: undefined,
    maskTextFn: undefined,
  },
  recordConsolePlugin: {
    level: ['error'] as LogLevel[],
    lengthThreshold: Number.POSITIVE_INFINITY,
    stringifyOptions: {
      stringLengthLimit: Number.POSITIVE_INFINITY,
      numOfKeysLimit: Number.POSITIVE_INFINITY,
      depthOfLimit: Number.POSITIVE_INFINITY,
    },
  },
  samplingOptions: {
    scroll: 150,
    media: 1000,
    canvas: 8,
    input: 'last' as const,
  },
};

class Recorder {
  static mockImplementation(arg0: () => any) {
    throw new Error('Method not implemented.');
  }
  options;
  stop: (() => void) | null;

  constructor(handleEvent: { (event: any): void; (event: any): void }) {
    this.options = {
      ...defaultOptions.recordOptions,
      emit: handleEvent,
      plugins: [getRecordConsolePlugin(defaultOptions.recordConsolePlugin)],
      sampling: defaultOptions.samplingOptions,
    };
    this.stop = null;
  }

  start() {
    this.stop = record(this.options) ?? null;
  }

  getMirror() {
    return record.mirror;
  }

  takeFullSnapshot() {
    return record.takeFullSnapshot();
  }
}

export default Recorder;
